<template>
  <div>
    {{ props.payload.content }}
  </div>
</template>

<script lang="ts">
import { customerServicePayloadType } from '../../../../../../interface';

interface Props {
  payload: customerServicePayloadType;
}

export default {
  props: {
    payload: {
      type: Object as () => customerServicePayloadType,
      default: () => ({}),
    },
  },
  setup(props: Props) {
    return {
      props,
    };
  },
};
</script>
<style lang="scss" scoped>
</style>
